/** English defaults for /conference and nested pages — shared by seed and UI. */

export const conferenceEn = {
  main: {
    bannerTitle: 'CONFERENCE',
    articleTitle: 'The Advances in Applied Engineering Sciences',
    articleBody:
      'A peer-reviewed journal dedicated to the latest advancements and practical innovations in applied engineering sciences. The goal of this publication is to present research that offers cutting-edge solutions to pressing engineering and technological challenges, supporting both theoretical progress and the practical application of engineering solutions. Key areas of focus include sustainable energy systems, renewable energy sources, advanced materials, digital technologies, mechanical and transportation systems, and the development of human capital in engineering. The journal caters to a broad readership, including researchers, practitioners, and industry professionals. Publications emphasize real-world applications of innovations that enhance productivity and promote the sustainable development of industrial processes. "Advances in Applied Engineering Sciences" aims to maintain high standards of peer review and to publish impactful research that helps shape the future of applied engineering.',
    heroImage: '/Images/conference-hero.jpg',
    heroImageAlt: 'Engineering team',
    committeeTitle: 'Committee Organization',
    countryLabel: 'Country:',
    workplaceLabel: 'Workplace:',
    members: {
      c1: { name: 'Aleksandra Kureevna', country: 'Russia', workplace: 'AMITY Tech Labs' },
      c2: { name: 'Akhmed Mubassar', country: 'Uzbekistan', workplace: 'VUJT / MIT' },
      c3: { name: 'Roza Ivanova', country: 'Russia', workplace: 'Yandex Labs' },
      c4: { name: 'John Creed', country: 'USA', workplace: 'Google (ex)' },
      c5: { name: 'Emily Zhang', country: 'China', workplace: 'Stanford Engineering' },
      c6: { name: 'Michael Brown', country: 'UK', workplace: 'Oxford University' },
      c7: { name: 'Sophie Laurent', country: 'France', workplace: 'EU Commission' },
      c8: { name: 'David Green', country: 'USA', workplace: 'NASA' },
    },
  },
  pastNew: {
    bannerTitle: 'CONFERENCE',
    pageTitle: 'Past and further conferences',
    registerButtonUrl: 'https://easychair.org/registration',
    registerButtonLabel: 'Register',
    cards: {
      card1: {
        title: 'Global Visibility:',
        description: 'Your research will reach thousands of readers worldwide.',
        date: 'April 2024',
      },
      card2: {
        title: 'Global Visibility:',
        description: 'Your research will reach thousands of readers worldwide.',
        date: 'April 2024',
      },
      card3: {
        title: 'Global Visibility:',
        description: 'Your research will reach thousands of readers worldwide.',
        date: 'April 2024',
      },
      card4: {
        title: 'Global Visibility:',
        description: 'Your research will reach thousands of readers worldwide.',
        date: 'April 2024',
      },
      card5: {
        title: 'Global Visibility:',
        description: 'Your research will reach thousands of readers worldwide.',
        date: 'April 2024',
      },
      card6: {
        title: 'Global Visibility:',
        description: 'Your research will reach thousands of readers worldwide.',
        date: 'April 2024',
      },
    },
  },
  register: {
    title: 'Register to participate in upcoming conferences',
    infoText:
      'To join our conferences, please complete the registration using the link below. After submitting your information, our team will contact you with confirmation details.',
    buttonUrl: 'https://easychair.org/registration',
    buttonLabel: 'Go to Registration',
  },
  accommodation: {
    title: 'Accommodation at Tashkent University of Applied Sciences',
    subtitle:
      'The ANMIS conference recommends several accommodation options near Tashkent University of Applied Sciences, Uzbekistan.',
    optionPrefix: 'Option',
    opt1: {
      title: 'University Guest House',
      badge: 'If available',
      p1: 'Tashkent University of Applied Sciences may have its own guest house or dormitory for conference attendees.',
      p2: 'Reservations can be made directly through the university administration by phone, provide both accommodation and event facilities',
      p3: 'This option ensures the closest proximity to the conference venue.',
    },
    opt2: {
      title: 'Hotels Near the University',
      badge: '',
      p1: 'Several hotels of varying comfort levels and price ranges are located in the vicinity of the university.',
      p2: 'We recommend using platforms such as Booking.com, Hotels.com or similar online services to select and reserve a suitable option.',
      p3: "Make sure to verify the hotel's location relative to Tashkent University of Applied Sciences.",
    },
    opt3: {
      title: 'Apartment Rentals',
      badge: '',
      p1: 'For longer stays or those who prefer a more home-like environment, consider renting an apartment.',
      p2: 'Online platforms such as iJARA and AX offer a wide selection of apartments in Tashkent.',
      p3: '',
    },
    infoTitle: 'Important Information:',
    infoLi1: 'Conference attendees are responsible for making their own accommodation reservations.',
    infoLi2:
      'We recommend booking accommodations in advance, especially if you plan to attend the conference during peak season.',
    mapLabel: 'University of Applied Sciences',
  },
};
